import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { SexesService } from 'src/app/services/sexes.service';
import { SexesModalComponent } from './sexes-modal/sexes-modal.component';



@Component({
  selector: 'app-sexes',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './sexes.component.html',
  styleUrls: ['./sexes.component.css']
})
export class SexesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private SexesService: SexesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  SexesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getSexes();
  }

  getSexes(){
    this.SexesService.getSexes().subscribe({
      next: (res: any) => {
        this.SexesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(SexesModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getSexes();
        }
      }
    });
  }

}
